<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="3">
                  <p-input v-model.trim="form.gameName" label="Game Name" name="gameName" :handler="$v" :formData="form"/>
                </b-col>
                <b-col sm="3">
                  <p-select v-model="form.gameTag" name="gameTag" :options="gameTagOption" :handler="$v" :formData="form" label="Game Tags"/>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-for="(item, key) in itemList" :key="key" sm="12" md="4">
        <b-card no-body class="overflow-hidden">
          <b-card-body>
            <b-row>
              <b-col sm="12" md="5">
                <template v-if="!getImage(item.GameId)">
                  <p><strong>OCMS Game Thumbnail</strong></p>
                  <img v-if="item.ImgUrl" :src="item.ImgUrl" width="150px" class="platform-image"/>
                </template>
                <template v-else>
                  <p><strong>{{ item.GameTag }} Thumbnail</strong></p>
                  <b-row>
                    <b-col v-for="(val, key) in getImage(item.GameId)" sm="12" md="12" :key="key">
                      <img width="100%" :src="val.ImgUrl" />
                    </b-col>
                  </b-row>
                </template>
              </b-col>
              <b-col sm="12" md="5">
                <b-row>
                  <b-col sm="12">
                    <b-row>
                      <b-col sm="12">
                        <p><strong>Game Name:</strong> {{ item.GameName }}</p>
                      </b-col>
                      <b-col sm="12">
                        <p><strong>Game Id:</strong> {{ item.GameId }}</p>
                      </b-col>
                      <b-col sm="12">
                        <p><strong>Game Tags:</strong> <b-badge variant="primary">{{ item.GameTag }}</b-badge></p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-col v-if="checkAccessPrivilege('CMS.GameImages.Update')" sm="2">
                <b-btn @click="showUpdateModal(item)" class="btn-sm" variant="info"><i class="fa fa-pencil"></i> Edit</b-btn>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <update-modal v-if="showModal" :show-modal="showModal" :update-data="updateData" :image-field="imageField" @closeModal="closeModal" />
  </div>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import UpdateModal from './Update'
import { PInput, PSelect } from '../../../components'
const _ = require('underscore')

export default {
  name: 'game-list',
  data () {
    return {
      form: {
        gameName: '',
        gameTag: 'all-games'
      },
      imageField: [],
      showModal: false,
      updateData: {},
      gameImages: {},
      items: []
    }
  },
  watch: {
    currentPage: function (val) {
      this.search()
    }
  },
  computed: {
    gameTagOption: {
      get: function () {
        return ['all-games', ...this.imageField]
      }
    },
    itemList: {
      get: function () {
        const { gameName, gameTag } = this.form
        const regex = gameName ? new RegExp(gameName.toUpperCase() + '.*') : null

        return _.chain(this.items)
          .filter((x) => {
            const nameMatch = !gameName || x.GameName.toUpperCase().match(regex)
            const tagMatch = !gameTag || gameTag === 'all-games' || x.GameTag === gameTag
            return nameMatch && tagMatch
          })
          .value()
      }
    }
  },
  validations: {
    form: {
      gameName: {},
      gameTag: {}
    }
  },
  components: {
    UpdateModal,
    PInput,
    PSelect
  },
  methods: {
    getImage (id) {
      return this.gameImages[id]
    },
    async getImageField () {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.get(this.API_ENDPOINT + '/game/image/imageField')
        this.imageField = data.fields
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async getGameImages () {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.post(this.API_ENDPOINT + '/game/image/getList', { headers: { 'Content-Type': 'application/json' } })
        this.gameImages = data.data
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async search () {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.get(this.API_ENDPOINT + '/game/gamelistByTags?tags=' + this.imageField.join(','), { headers: { 'Content-Type': 'application/json' } })
        this.items = data.data
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    showUpdateModal (item) {
      this.showModal = true
      this.updateData = { ...item, GameImages: this.gameImages[item.GameId] }
    },
    closeModal () {
      this.showModal = false
      this.updateData = {}
      this.getGameImages()
    },
    checkAccessPrivilege (module, title = false) {
      if (!module) return true
      if (title) return (JSON.stringify(this.PRIVILEGE).includes(module))
      return this.PRIVILEGE.includes(module)
    }
  },
  async created () {
    await this.getImageField()
    await this.search()
    await this.getGameImages()
  }
}
</script>

<style scoped>
.platform-image {
  filter: drop-shadow(2px 4px 6px black);
}
</style>



// WEBPACK FOOTER //
// src/views/game/images/Images.vue